import LoginCard from "components/LoginCard";
import "./styles.css";

const Login = () => {
  return (
    <div className="login-page-container">
      <LoginCard />
    </div>
  );
};

export default Login;
